import { render, staticRenderFns } from "./ForgotPasswordDialog.vue?vue&type=template&id=8bafc828&"
import script from "./ForgotPasswordDialog.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports